import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationHistory {
  private history: string[] = [];
  private _currentUrl$ = new BehaviorSubject<string>(null);

  constructor(private router: Router) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(({ urlAfterRedirects }: NavigationEnd) => {
        this.history = [...this.history, urlAfterRedirects];
        this._currentUrl$.next(urlAfterRedirects);
      });
  }

  public getPreviousUrlOrDefault(): string {
    if (this.history.length > 1) {
      return this.history[this.history.length - 2];
    } else {
      return null;
    }
  }

  public get currentUrl$(): Observable<string> {
    return this._currentUrl$.asObservable();
  }
}
